import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as content from './content'
import * as switchers from './switchers'

/** TODO:  */
@ngCore.Component({
  imports: [
    switchers.enum.Component,
    switchers.intrinsic.Component,
    switchers.structure.Component,
    content.standard.Component,
  ],
  selector: 'atn-ds-value',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link ents.core.common.value.Raw} */
  public readonly valueSg = ngCore.input.required<
    ents.core.common.value.Raw | undefined
  >({
    alias: 'value',
  })

  /** TODO:  */
  public readonly valueInfoSg = ngCore.input<
    ents.core.common.value.Info | undefined
  >(undefined, {
    alias: 'valueInfo',
  })

  /** */
  public readonly typeSg = ngCore.computed(
    (valueInfo = this.valueInfoSg(), value = this.valueSg()) =>
      valueInfo?.type ??
      ents.core.common.value.types.Intrinsic.inferFrom(value),
  )

  /** @see {@link ents.core.common.value.Raw}  */
  public readonly intrinsicValueSg = ngCore.computed(
    (type = this.typeSg(), value = this.valueSg()) =>
      ents.core.common.value.types.Intrinsic.isIntrinsic(type)
        ? ents.core.common.value.Raw.cast(value, type)
        : undefined,
  )

  /** @see {@link ents.core.common.value.Raw}  */
  public readonly enumTypedValueSg = ngCore.computed(
    (type = this.typeSg(), value = this.valueSg()) =>
      type instanceof ents.core.common.value.types.Enum
        ? { type, value: ents.core.common.value.Raw.cast(value, type) }
        : undefined,
  )

  /** @see {@link ents.core.common.value.Raw}  */
  public readonly structureTypedValueSg = ngCore.computed(
    (type = this.typeSg(), value = this.valueSg()) =>
      type instanceof ents.core.common.value.types.Structure
        ? { type, value: ents.core.common.value.Raw.cast(value, type) }
        : undefined,
  )
}
